import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, computed, watch } from "vue";
  import { POSITION, useToast } from "vue-toastification";
  import { useStore } from "vuex";
  import { AnalyticsDataItem } from "@/types/AnalyticsDataInterface";
  import { EstateInterface } from "@/types/EstateInterface";
  import ReportsByNumber from "@/components/reports/ReportsByNumber.vue";
  import { dataSiteVisitors } from "@/constants/dataForAnalytics";
  import { getAnalyticsData } from "@/helpers/analytics/getAnalyticsData";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SiteVisitorsFromAnalytics',
  props: {
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
    searchKey: {
      type: Number,
      required: true,
    },
    estateSelected: {
      type: String,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const toast = useToast();
  const loading = ref(false);
  const store = useStore();
  const DataFromAnalytics = ref<AnalyticsDataItem[]>([]);
  const estate = ref<EstateInterface>();

  const landownerId = computed(() => store.state.user.data._id);

  const startDateSelected = computed(() => {
    return props.startDate;
  });

  const endDateSelected = computed(() => {
    return props.endDate;
  });

  const estateSelected = computed(() => {
    return props.estateSelected;
  });

  watch(
    () => props.searchKey,
    () => {
      fetchDataFromAnalytics();
    }
  );

  const fetchDataFromAnalytics = async () => {
    await getAnalyticsData(
      startDateSelected.value,
      endDateSelected.value,
      dataSiteVisitors,
      DataFromAnalytics,
      loading,
      store,
      toast
    );
  };

  const getEstate = () => {
    if (estateSelected.value) {
      store
        .dispatch("estate/getEstate", estateSelected.value)
        .then((res) => {
          estate.value = res.data;
        })
        .catch((error) => {
          toast.error("Error getting estates", { position: POSITION.TOP_LEFT });
        });
    }
  };

  const filteredDataFromAnalytics = computed(() => {
    if (estate.value && DataFromAnalytics.value.length > 0) {
      const estateTitle = estate.value.title;

      return DataFromAnalytics.value.filter(
        (estateByAnalytics) =>
          estateByAnalytics.dimensionValues[0].value === estateTitle
      );
    }

    return [];
  });

  const ReportFromAnalyticsNumber = computed(() => {
    if (!filteredDataFromAnalytics.value.length) {
      return 0;
    }

    return parseInt(filteredDataFromAnalytics?.value[0].metricValues[0].value);
  });

  onMounted(() => {
    fetchDataFromAnalytics();
    getEstate();
  });

const __returned__ = { props, toast, loading, store, DataFromAnalytics, estate, landownerId, startDateSelected, endDateSelected, estateSelected, fetchDataFromAnalytics, getEstate, filteredDataFromAnalytics, ReportFromAnalyticsNumber, onMounted, ref, computed, watch, get POSITION() { return POSITION }, get useToast() { return useToast }, get useStore() { return useStore }, get AnalyticsDataItem() { return AnalyticsDataItem }, get EstateInterface() { return EstateInterface }, ReportsByNumber, get dataSiteVisitors() { return dataSiteVisitors }, get getAnalyticsData() { return getAnalyticsData } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})